import React, { useState } from 'react';
import { Handle, Position } from 'reactflow';
import { usePipeline } from '../PipelineContext';

const HUMAN_INFO = {
  what: 'A real person in the workflow — they can provide input, give approval, or be the start/end of a pipeline flow.',
  examples: ['Business Owner approving marketing content', 'Customer raising a support request'],
};

export default function HumanNode({ data, selected }) {
  const [showInfo, setShowInfo] = useState(false);
  const { opsMode } = usePipeline() || {};
  const headerStyle = data.color ? { background: data.color + '22', color: data.color } : {};
  const nodeStyle   = data.color ? { borderColor: data.color } : {};

  return (
    <div className={`pipeline-node human-node ${selected ? 'selected' : ''}`} style={nodeStyle}>
      <Handle type="target" position={Position.Left}  className="node-handle" />

      <div className="node-header human-header" style={headerStyle}>
        <span className="node-type-icon">👤</span>
        <span className="node-type-label">{opsMode ? 'Stakeholder' : 'Human'}</span>
        <button className="node-info-btn" onMouseDown={e => e.stopPropagation()} onClick={e => { e.stopPropagation(); setShowInfo(s => !s); }}>ⓘ</button>
      </div>

      <div className="node-body">
        <div className="node-title">{data.label}</div>
        {data.description && <div className="node-description">{data.description}</div>}
        {showInfo && (
          <div className="node-info-card">
            <div className="node-info-what">{HUMAN_INFO.what}</div>
            <div className="node-info-eg-label">Examples:</div>
            {HUMAN_INFO.examples.map((ex, i) => <div key={i} className="node-info-eg">→ {ex}</div>)}
          </div>
        )}
        <div className="human-node-badge" style={data.color ? { background: data.color + '22', color: data.color } : {}}>
          {opsMode ? 'Stakeholder input' : 'Human input required'}
        </div>
      </div>

      <Handle type="source" position={Position.Right} className="node-handle" />
    </div>
  );
}
